import { useEffect, useRef } from "react";
import { useSocket } from "../context/SocketContext";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setQuizLiveGame } from "../slices/fun_stuff/quizAuthSlice";

export const useHandleLiveGame = () => {
    const socket = useSocket();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { quizLiveGame } = useSelector(state => state.quizAuth);

    const liveGameRef = useRef(quizLiveGame);

    useEffect(() => {
        liveGameRef.current = quizLiveGame;
    }, [quizLiveGame]);

    useEffect(() => {
        if (!socket) return;
        console.log('Setting up game_event listenter');
    
        const handleLiveGameUpdate = ({ groupId, type, payload }) => {
            if (groupId !== liveGameRef.current.groupId) {
                return;
            }

            if (type === 'update_group') {
                dispatch(setQuizLiveGame({ 
                    ...liveGameRef.current, 
                    participants: payload.currentMembers, 
                    groupReady: payload.groupReady, 
                    topicsRemaining: payload.topicsRemaining,
                 }));
            } else if (type === 'quiz_received') {
                const numQuestions = liveGameRef.current.participants.length * payload.quiz.questions.length;
                dispatch(setQuizLiveGame({ 
                    ...liveGameRef.current, 
                    numQuestions, 
                    startActive: false, 
                    completed: false, 
                }));
                navigate('/quizgame#title', {
                    state: {
                        gradeQuiz: true,
                        liveQuiz: payload.quiz,
                    }   
                });
            } else if (type === 'game_completed') {
                console.log('Game completed', payload)
                dispatch(setQuizLiveGame({ 
                    ...liveGameRef.current, 
                    completed: true, 
                    participants: payload.currentMembers, 
                    topicsRemaining: payload.topics.length, 
                    groupReady: false,
                    currQuiz: payload.currQuiz,
                    currTotals: payload.currTotals,
                    inAction: false,
                }));
            } else if (type === 'game_started') {
                dispatch(setQuizLiveGame({ 
                    ...liveGameRef.current, 
                    startActive: true,
                    topic: payload.topic, 
                    level: payload.level,
                }));
                navigate('/quizgame/quizprofile', { 
                    replace: true, 
                    quizCompleted: false,
                });
            } else if (type === 'reset_game') {
                dispatch(setQuizLiveGame({ 
                    ...liveGameRef.current, 
                    paramsSubmitted: false,
                    participants: payload.currentMembers,
                    completed: false, 
                }));
            }
        }
    
        socket.on('game_update', handleLiveGameUpdate);
    
        return () => {
            socket.off('game_update', handleLiveGameUpdate);
        };
    }, [socket, dispatch, navigate]);
}